import React from 'react'
import { PropTypes } from 'prop-types'
import { green } from '../../../utils/constants'

const InfoSaved = ({ section,custommessage }) => {
    const style = { color: green, fontWeight: 'bold', margin: '20px',marginTop:'-50px' }
    const message = custommessage ? custommessage : section + ' successfully updated.'
  
    return (
            <span style={style}>
                <br /><br />{' '}<i className='fa fa-check' aria-hidden="true" />{' '}{ message}
            </span>)
}
InfoSaved.propTypes = {
    section: PropTypes.string,
    custommessage: PropTypes.string
}
export default InfoSaved


// WEBPACK FOOTER //
// ./src/containers/season/components/InfoSaved.js